var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7074 4.51145L10.3209 0.0548481C10.1177 -0.0182827 9.91448 -0.0182827 9.71155 0.0548481L0.325108 4.51145C0.12188 4.62102 0 4.80372 0 5.02285V14.9589C0 15.178 0.12188 15.3607 0.325108 15.4703L9.71155 19.9269C9.79289 19.9633 9.91477 20 9.99612 20C10.118 20 10.1994 19.9636 10.2807 19.9269L19.6671 15.4703C19.8704 15.3607 19.9922 15.178 19.9922 14.9589V5.02285C20.0328 4.80345 19.9109 4.62101 19.7077 4.51145H19.7074ZM9.99587 1.22366L18.0008 5.0226L9.99587 8.85826L6.58269 7.2509L10.6866 5.27844C11.0118 5.13243 11.1336 4.76704 10.9712 4.51119C10.8088 4.21892 10.4024 4.10935 10.1178 4.25536L5.24176 6.59324L2.03183 5.05901L9.99587 1.22366ZM1.25957 6.00896L4.67275 7.61632V12.5843C4.67275 12.913 4.95733 13.1689 5.32296 13.1689C5.68859 13.1689 5.97317 12.913 5.97317 12.5843L5.97288 8.23726L9.38606 9.84462V18.4656L1.25927 14.5935L1.25957 6.00896ZM10.646 18.4655V9.84456L18.7322 6.0089V14.6299L10.646 18.4655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.3c19edba98d839638b7cad1417e12301.svg";
export { ForwardRef as ReactComponent };